<template>
  <section class="flex justify-center items-center">
    <div class="container">
      <div class="-m-2 w-5/6 w-full lg:w-6/6 justify-center sm:justify-between">
        <div class="p-0 md:w-9/12 md:text-left">
          <h2 class="text-white text-left mt-6 heading" style="font-size: 40px">
            Soft-skill development at scale
          </h2>
<!--          <p class="text-left mt-2 md:mt-6 heading__two">-->
<!--          -->
<!--          </p>-->
          <!--          <p class="text-white text-left mt-6  mb-6">-->
          <!--            <a id="login" class="text-black ">Sign In</a>    </p>-->

          <img
            src="../../../../../../src/assets/images/pages/emotionhack/logo.png"
            class="heading__img"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "Header",
};
</script>
<style lang="scss" scoped>
.heading {
  width: 50%;
  font-weight: bolder;
  &__two {
    color: #ffffffca;
    width: 63%;
    font-size: 1.35em !important;
  }
  &__img {
    width: 10em;
    position: absolute;
    top: 87%;
    left: 15%;
  }
}
section {
  position: relative;
  min-height: 60vh;
  background: url("../../../../../../src/assets/images/pages/emotionhack/bg_hero.png")
    center;
  background-size: cover;
}
.alex-intro {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  padding: 4%;
}
.alex-intro p {
  font-size: 21px;
}
#login {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  /* line-height: 22px; */
  /* letter-spacing: -0.01em; */
  color: #3280fc;
  color: #3280fc;
  background: #ffffff;
  border-radius: 4px;
  padding: 10px 20px;
}

@media only screen and (max-width: 600px) {
  section {
    min-height: 30vh;
  }
  .heading {
    width: 95%;
    font-size: 1.5em !important;
    &__two {
      color: #ffffffca;
      width: 95%;
      font-size: 1em !important;
    }
    &__img {
      width: 5.5em;
      top: 90%;
      left: 2%;
    }
  }
  .vx-card__body {
    padding: 0.25rem !important;
    margin-left: -0.9em;
  }
}
</style>
